import { Box, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useEffect, useState } from 'react';
import { useScreenLargerThan } from '../../lib/hooks/breakpoint-hooks';
import InternalDatePicker, { INVALID_DATE } from '../Utils/InternalDatePicker';
import { InputDateProps } from './Reporting';

const FilterByDatePicker = ({ startDate, setStartDate, endDate, setEndDate }: InputDateProps) => {
    const isLargerThanSmall = useScreenLargerThan('sm');
    const [intervalError, setIntervalError] = useState(false);

    useEffect(() => {
        if (
            startDate.toString().toLowerCase() !== INVALID_DATE.toLowerCase() &&
            endDate.toString().toLowerCase() !== INVALID_DATE.toLowerCase()
        ) {
            const sDate = new Date(startDate);
            const eDate = new Date(endDate);

            //Reseting the hours, mins, seconds, miliseconds
            sDate.setHours(0, 0, 0, 0);
            eDate.setHours(0, 0, 0, 0);

            //Compare by miliseconds passed from epoch
            setIntervalError(sDate.getTime() > eDate.getTime());
        }
    }, [startDate, endDate]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
                sx={
                    isLargerThanSmall
                        ? { display: 'inline-flex' }
                        : { display: 'flex', justifyContent: 'space-between' }
                }>
                <Box
                    sx={
                        isLargerThanSmall
                            ? {
                                  display: 'flex',
                                  alignItems: 'center'
                              }
                            : { display: 'block' }
                    }>
                    <Typography sx={{ paddingRight: '12px' }}>Start Date</Typography>
                    <InternalDatePicker
                        sx={{ width: '150px' }}
                        min={''}
                        max={''}
                        dateValue={startDate}
                        intervalError={intervalError}
                        onDateChange={(v) => setStartDate(v, true)}
                    />
                </Box>
                <Box
                    sx={
                        isLargerThanSmall
                            ? {
                                  display: 'flex',
                                  alignItems: 'center'
                              }
                            : { display: 'block' }
                    }>
                    <Typography sx={{ padding: '0 12px' }}>End Date</Typography>
                    <InternalDatePicker
                        sx={{ width: '150px' }}
                        min={startDate}
                        max={''}
                        dateValue={endDate}
                        intervalError={intervalError}
                        onDateChange={(v) => setEndDate(v)}
                    />
                </Box>
            </Box>
        </LocalizationProvider>
    );
};

export default FilterByDatePicker;
